import React, { createContext, useState } from "react";

export const UnitSystemContext = createContext();

export const UnitSystemProvider = ({ children }) => {
  const [unitSystem, setUnitSystem] = useState("imperial");

  return (
    <UnitSystemContext.Provider value={{ unitSystem, setUnitSystem }}>
      {children}
    </UnitSystemContext.Provider>
  );
};

